














import Vue from 'vue';
import * as actions from '@/store/action-types';
import { ISession, IABTest } from '@/store/types';
import SessionOutcomes from '@/components/CancelAnalytics/SessionOutcomesLocalState.vue';
import { mapGetters } from 'vuex';
import { LOAD_STATE } from '@/store/shared';
import ABTestInfo from '@/components/Cancellation/ABTests/ABTestInfo.vue';

export default Vue.extend({
  name: 'CancellationABTest',
  components: {
    SessionOutcomes,
    ABTestInfo,
  },
  async created() {
    this.$store.dispatch(actions.FETCH_RECENT_SESSIONS);
  },
  props: {
    context: String,
  },
  data() {
    return {
      LOAD_STATE,
      abTest: {
        name: '',
        winner: '',
        segmentId: '',
      } as {
        [key: string]: string | IABTest | undefined;
        name: string;
        winner: string;
        segmentId: string;
        selectedABTest: IABTest | undefined;
      },
    };
  },
  computed: {
    ...mapGetters(['lowData', 'orgCreatedDate', 'daysSinceOrgCreated', 'provider', 'abTests']),
    sessionsLoading(): boolean {
      return this.$store.state.recentSessionsLoadState !== LOAD_STATE.LOADED;
    },
    sessions(): ISession[] {
      return this.$store.state.recentSessions;
    },
    testSessions(): ISession[] {
      return this.$store.state.testSessions;
    },
    currentABTest(): IABTest {
      console.log('this.abTests', this.abTests);
      return this.abTests.find((item: IABTest) => {
        if (item._id === this.$route.params.id) {
          return true;
        }
        return false;
      });
    },
  },
});
